export const SHAPES = {
    square: 'square',
    round: 'round',
};
export const COLORS = {
    standard: 'standard',
    blue: 'blue',
    cyan: 'cyan',
    teal: 'teal',
    green: 'green',
    purple: 'purple',
    violet: 'violet',
    pink: 'pink',
    orange: 'orange',
    red: 'red',
};
const prefix = 'composer-button';
export const dataHooks = {
    button: `${prefix}-button`,
};
//# sourceMappingURL=ComposerButton.constants.js.map